"use client";

import { getLayoutConfig } from '@/components/Layout/LayoutConfiguration';
import { FeatureFlagInitializer } from '@/molecules/FeatureFlagInitializer';
import flagsmith from "flagsmith/isomorphic";
import { FlagsmithProvider } from "flagsmith/react";
import { SessionProvider } from 'next-auth/react';
import { usePathname, useSearchParams } from "next/navigation";
export default function Provider({
  children,
  flagsmithState,
  session
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const manager = searchParams.get('manager');

  let layoutConfig = getLayoutConfig(pathname, session, manager);
  const { Layout: FetchedLayout } = layoutConfig;
  return (
    <FlagsmithProvider flagsmith={flagsmith} serverState={flagsmithState}>
      <SessionProvider>
        <FetchedLayout >
          <FeatureFlagInitializer>
            {children}
          </FeatureFlagInitializer>
        </FetchedLayout>
      </SessionProvider>
    </FlagsmithProvider>
  );
}